import { render, staticRenderFns } from "./BaseTeacherPicker.vue?vue&type=template&id=dc7c1558&"
import script from "./BaseTeacherPicker.vue?vue&type=script&lang=js&"
export * from "./BaseTeacherPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports